import { layoutNodes } from './layout.js';
import {
  drawBackground,
  drawConnections,
  drawFallback,
  drawLabel,
  drawNode
} from './drawingPrimitives.js';

export function drawDiagram({ canvas, ctx, wrapper, definition, state, dimensions }) {
  const width = dimensions.width;
  const height = dimensions.height;
  const dpr = window.devicePixelRatio || 1;

  canvas.width = width * dpr;
  canvas.height = height * dpr;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  ctx.setTransform?.(dpr, 0, 0, dpr, 0, 0);

  state.dimensions = { width, height };
  state.displayNodes = layoutNodes(definition.nodes, width, height);

  ctx.clearRect(0, 0, width, height);
  drawBackground(ctx, width, height);

  if (definition.nodes.length === 0) {
    drawFallback(ctx, width, height, definition.label);
    wrapper.dataset.publicDiagramStatus = 'fallback';
    return;
  }

  drawConnections(ctx, state.displayNodes, definition.connections);
  state.displayNodes.forEach(node => drawNode(ctx, node, state.hoverNode?.id === node.id));
  drawLabel(ctx, width, height, definition.label);
  wrapper.dataset.publicDiagramStatus = 'ready';
}
